/**
 * Los nombres de los módulos.
 *
 * TWO ARE LEFT IN ENGLISH ON PURPOSE, and the reason is the same one the QR page gives for leaving a
 * server message untranslated: a wrong word is worse than an English one.
 *
 *   • `crm` — the acronym is what Spanish-language business software prints (Salesforce, HubSpot and
 *     Zoho all say "CRM" in their Spanish UIs), so translating it to "Clientes" would invent a name
 *     nobody outside this application uses. It is also an office-role module: no foreman has it.
 *   • `pdfreader` keeps "PDF", which is a file format and not a word in any language.
 *
 * `bidworkup` is `Presupuestos` — an estimate/quotation, which is what the module actually produces.
 * `bid_request` is `Solicitud de presupuesto`, the request FOR one, so the two read as the pair they
 * are rather than as two unrelated screens.
 *
 * `timekeeping` is `Control de horas` and not `Registro de horas`: a foreman on this screen is not
 * only recording hours, he is having them reviewed and approved. The whole module carries that word,
 * so it is chosen once here and never re-decided per screen.
 */
export default {
  identity: 'Mi perfil',
  timekeeping: 'Control de horas',
  projects: 'Proyectos',
  crm: 'CRM',
  hr: 'Recursos Humanos',
  hrShort: 'Recursos Humanos',
  bidworkup: 'Presupuestos',
  bid_request: 'Solicitud de presupuesto',
  finance: 'Finanzas y Contabilidad',
  financeShort: 'Finanzas',
  documents: 'Control de Documentos',
  documentsShort: 'Documentos',
  fleet: 'Flota y Equipo',
  fleetShort: 'Flota',
  inventory: 'Inventario',
  officeboard: 'Tablero de la Oficina',
  pdfreader: 'Lector de PDF',
  forms: 'Formularios',
  // "Proyectos de capital" rather than "Proyectos de inversión": the English here means capital
  // WORKS — a built job — not a capital investment, and `inversión` would name the wrong thing to
  // the one reader this dictionary exists for.
  capital: 'Proyectos de capital',
  // Aligned with `projects: 'Proyectos'` above when the module was renamed jobs→projects
  // (2.99.24): it reads from Projects, so it carries the same word.
  capex: 'Finanzas de proyectos',
  // The everyday word for the billing office's work; distinct from `capex` above on purpose.
  invoicing: 'Facturación',
  // The AI Office Worker: "asistente" is the word a Spanish-speaking office uses for the role.
  office_worker: 'Asistente de oficina',
  compliance: 'Cumplimiento',
  procurement: 'Compras',
}
